var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "li",
    [
      _c(
        "router-link",
        {
          attrs: {
            to: {
              name: "system.notifications.show",
              params: { id: _vm.notification.id },
            },
          },
        },
        [
          _c("div", { staticClass: "row" }, [
            _c("div", { staticClass: "col-xs-9 col-md-10" }, [
              _c("h3", [_vm._v(_vm._s(_vm.notification.title))]),
              _vm._v(" "),
              _c("p", [_vm._v(_vm._s(_vm.notification.content))]),
              _vm._v(" "),
              _c("br"),
              _vm._v(" "),
              _c("p", [
                _c("i", { staticClass: "fa fa-calendar fa-fw" }),
                _vm._v(
                  " Sent: " +
                    _vm._s(
                      _vm._f("timeTimezone")(
                        _vm.notification.created_at,
                        _vm.$user.timezone
                      )
                    ) +
                    " on\n          " +
                    _vm._s(
                      _vm._f("dateTimezone")(
                        _vm.notification.created_at,
                        _vm.$user.timezone,
                        _vm.$user.date_format_preference
                      )
                    )
                ),
              ]),
              _vm._v(" "),
              _c("p", [
                _c("i", { staticClass: "fa fa-user fa-fw" }),
                _vm._v(" Sent By: " + _vm._s(_vm.notification.creator)),
              ]),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "col-xs-3 col-md-2 text-right" }, [
              _c("h2", { class: _vm.percentageColour }, [
                _vm._v(_vm._s(_vm.talentResponseRate)),
              ]),
              _vm._v(" "),
              _c("p", [_vm._v("Responded")]),
            ]),
          ]),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }